import { Badge, Color } from "baseui/badge";
import { SHAPE } from "baseui/button";
import { useMemo } from "react";

enum EEstateStatus {
  PLANNING = "planning",
  PRECONSTRUCTION = "preconstruction", 
  UNDERCONSTRUCTION = "underconstruction",
  PAUSED = "paused",
  COMPLETED = "completed",
  DELIVERED = "delivered",
  CANCELLED = "cancelled"
}

type EstateStatusProps = {
  row?: { value: string };
};

export const EstateStatus = ({ row }: EstateStatusProps) => {
  if (!row) return null;

  const statusValue = row.value || "";
  
  const statusData = useMemo(() => {
    switch (statusValue) {
      case EEstateStatus.PLANNING:
        return { 
          color: "neutral" as Color, 
          label: "Planning",
          bgColor: "rgba(134, 134, 134, 0.2)",
          textColor: "#555555"
        };
      case EEstateStatus.PRECONSTRUCTION:
        return { 
          color: "accent" as Color, 
          label: "Preconstruction",
          bgColor: "rgba(78, 109, 237, 0.2)",
          textColor: "#1d3fa3"
        };
      case EEstateStatus.UNDERCONSTRUCTION:
        return { 
          color: "warning" as Color, 
          label: "Under Construction",
          bgColor: "rgba(255, 201, 71, 0.2)",
          textColor: "#805b00"
        };
      case EEstateStatus.PAUSED:
        return { 
          color: "warning" as Color, 
          label: "Paused",
          bgColor: "rgba(255, 176, 0, 0.2)",
          textColor: "#b8860b"
        };
      case EEstateStatus.COMPLETED:
        return { 
          color: "accent" as Color, 
          label: "Completed",
          bgColor: "rgba(25, 25, 112, 0.2)",
          textColor: "#191970"
        };
      case EEstateStatus.DELIVERED:
        return { 
          color: "positive" as Color, 
          label: "Delivered",
          bgColor: "rgba(71, 184, 129, 0.2)",
          textColor: "#1e633e"
        };
      case EEstateStatus.CANCELLED:
        return { 
          color: "negative" as Color, 
          label: "Cancelled",
          bgColor: "rgba(237, 78, 80, 0.2)",
          textColor: "#a31d1f"
        };
      default:
        return { 
          color: "neutral" as Color, 
          label: statusValue || "No Status",
          bgColor: "rgba(134, 134, 134, 0.2)",
          textColor: "#555555"
        };
    }
  }, [statusValue]);

  return (
    <Badge
      hierarchy="primary"
      color={statusData.color}
      shape={SHAPE.pill}
      content={statusData.label}
      overrides={{
        Badge: {
          style: {
            backgroundColor: statusData.bgColor,
            color: statusData.textColor,
            fontWeight: 500
          }
        }
      }}
    />
  );
}; 